import axios from 'axios';
import {CONF_AUTH} from '../config/ConfigAuth';

axios.defaults.withCredentials = false;
export default axios.create({
    baseURL: CONF_AUTH.AUTH_SERVER_HOST,
    headers: {        
		'Accept': 'application/json',        
        'Content-Type': 'application/x-www-form-urlencoded'

    }
});